import React from 'react';

const colorPalettes = [
  {
    name: 'Neon Cyberpunk',
    colors: ['#00FFFF', '#FF00FF', '#FFFF00', '#0000FF']
  },
  {
    name: 'Pastel Dream',
    colors: ['#FFD1DC', '#FFECB3', '#B5EAD7', '#C7CEEA']
  },
  {
    name: 'Forest Depths',
    colors: ['#2D4739', '#5A7247', '#8B9D77', '#C5D6A2']
  },
  {
    name: 'Ocean Sunset',
    colors: ['#003B46', '#07575B', '#66A5AD', '#F4B942']
  },
  {
    name: 'Desert Heat',
    colors: ['#662E1C', '#AF4425', '#F2921D', '#FFC288']
  },
  {
    name: 'Midnight Galaxy',
    colors: ['#0F1123', '#1E2040', '#534D8A', '#A997DF']
  },
  {
    name: 'Autumn Harvest',
    colors: ['#A0522D', '#CD853F', '#D2B48C', '#8B4513']
  },
  {
    name: 'Arctic Ice',
    colors: ['#E0FFFF', '#B0E0E6', '#87CEEB', '#4682B4']
  }
];

const ColorPalettePicker = ({ selectedPalette, onPaletteChange }) => {
  return (
    <div className="mt-8 mb-2">
      <label className="block text-white font-medium mb-3">
        🎨 Color Palette (optional)
      </label>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {colorPalettes.map((palette) => {
          const isSelected = selectedPalette?.name === palette.name;
          
          return (
            <button
              key={palette.name}
              onClick={() => onPaletteChange(isSelected ? null : palette)}
              className={`clay-button p-3 transition-all highlight-hover ${
                isSelected ? 'ring-2 ring-green-500 ring-offset-1 ring-offset-gray-900' : ''
              }`}
            >
              <div className="flex mb-2">
                {palette.colors.map((color) => (
                  <div
                    key={color}
                    style={{ backgroundColor: color }}
                    className="h-6 flex-1 first:rounded-l-md last:rounded-r-md"
                  ></div>
                ))}
              </div>
              <p className="text-xs text-gray-300 text-center">{palette.name}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ColorPalettePicker;